import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { removeEmoji, formateISODateToMoment } from "@/utils";

const RelatedObjectsTable = ({ objects }) => {
  const styles = StyleSheet.create({
    table: {
      display: "table",
      width: "auto",
      borderWidth: 1,
      borderColor: "#E9E9E9",
      borderStyle: "solid",
      borderRadius: 6,
    },
    tableRow: {
      flexDirection: "row",
      borderBottomWidth: 1,
      borderColor: "#F7F7F7",
      // minHeight: 22,
    },
    tableRowFirst: {
      borderTopLeftRadius: 6,
      borderTopRightRadius: 6,
      backgroundColor: "#F8FBFF",
      color: "#777777",
      borderBottomWidth: 0,
    },

    tableHeadCol: {
      padding: "7px 8px",
      width: 178,
      //   borderRightWidth: 1,
      //   borderColor: "#E9E9E9",
      overflow: "hidden",
    },

    tableRowLast: {
      borderBottomWidth: 0,
      borderBottomLeftRadius: 6,
      borderBottomRightRadius: 6,
    },

    tableCol: {
      width: 178,
      padding: "6px 8px",
      //   borderRightWidth: 1,
      //   borderColor: "#E9E9E9",
      overflow: "hidden",
      // minHeight: 21,
    },
    firstCol: {
      width: 30,
      minWidth: 30,
    },
    lastCol: {
      borderRightWidth: 0,
      width: 100,
      minWidth: 100,
    },
  });

  return (
    <View style={styles.table}>
      <View style={[styles.tableRow, styles.tableRowFirst]} wrap={false}>
        <View style={[styles.tableHeadCol, styles.firstCol]} wrap={false}>
          <Text>№</Text>
        </View>
        <View style={styles.tableHeadCol} wrap={false}>
          <Text>Название</Text>
        </View>
        <View style={styles.tableHeadCol} wrap={false}>
          <Text>Тип</Text>
        </View>
        <View style={[styles.tableHeadCol, styles.lastCol]} wrap={false}>
          <Text>Дата создания</Text>
        </View>
      </View>
      {/* Table rows */}
      {objects.map((data, index) => (
        <View
          key={index}
          wrap={false}
          style={[
            styles.tableRow,
            index === objects.length - 1 && styles.tableRowLast,
          ]}
        >
          <View style={[styles.tableCol, styles.firstCol]} wrap={false}>
            <Text>{index + 1}</Text>
          </View>
          <View style={styles.tableCol} wrap={false}>
            <Text>{data.object_name}</Text>
          </View>
          <View style={styles.tableCol} wrap={false}>
            <Text>{removeEmoji(data.definition_name)}</Text>
          </View>
          <View style={[styles.tableCol, styles.lastCol]} wrap={false}>
            <Text>{formateISODateToMoment(data.created_at)}</Text>
          </View>
        </View>
      ))}
    </View>
  );
};

export default RelatedObjectsTable;
